/* eslint-disable */
/**
 * Kokobay PDP As Seen On widget — Shopify theme snippet / app embed.
 *
 * Looks up live As Seen On images by variant or style SKU and renders the
 * same “As seen on...” gallery as the admin live preview.
 *
 * INSTALL
 * -------
 * 1. Set AS_SEEN_ON_API_BASE to your Kokobay API host.
 * 2. In theme.liquid (same pattern as the fit widget, different filenames):
 *      {{ 'kokobay-as-seen-widget.css' | asset_url | stylesheet_tag }}
 *      <script src="{{ 'kokobay-as-seen-widget.js' | asset_url }}" defer></script>
 * 3. On the product page, add:
 *      <div id="kokobay-as-seen-on" data-sku="{{ product.selected_or_first_available_variant.sku }}"></div>
 * 4. Open a product URL with ?test=true (or &test=true). The widget is a no-op otherwise.
 *
 * Renders into #kokobay-as-seen-on only. SKU comes from data-sku if present,
 * otherwise the selected Shopify variant.
 */

var AS_SEEN_ON_API_BASE = "https://kokobay-mizd.vercel.app/api/as-seen-on/images";

var lastSku = null;
var lastProductKey = null;
var carouselBound = false;

var IG_ICON =
  '<svg viewBox="0 0 256 256" aria-hidden="true" focusable="false">' +
  '<path fill="currentColor" d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"/>' +
  "</svg>";

var CARET_LEFT =
  '<svg viewBox="0 0 256 256" aria-hidden="true" focusable="false">' +
  '<path fill="currentColor" d="M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"/>' +
  "</svg>";

var CARET_RIGHT =
  '<svg viewBox="0 0 256 256" aria-hidden="true" focusable="false">' +
  '<path fill="currentColor" d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"/>' +
  "</svg>";

function isTestQueryEnabled() {
  return true
}

function normalizeSku(s) {
  return String(s || "")
    .trim()
    .toUpperCase();
}

function escapeHtml(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function safeHttpUrl(raw) {
  var s = String(raw || "").trim();
  if (!s) return "";
  try {
    var u = new URL(s, window.location.href);
    if (u.protocol === "http:" || u.protocol === "https:") return u.href;
  } catch (e) {}
  return "";
}

function instagramUsername(raw) {
  return String(raw || "")
    .replace(/^@+/, "")
    .trim();
}

function instagramHref(item) {
  var post = safeHttpUrl(item && item.instagramPostUrl);
  if (post) return post;
  var user = instagramUsername(item && item.instagramUsername);
  if (!user) return "";
  return "https://www.instagram.com/" + encodeURIComponent(user) + "/";
}

function getSkuFromContainer() {
  var container = document.getElementById("kokobay-as-seen-on");
  if (!container || !container.dataset || !container.dataset.sku) return null;
  return normalizeSku(container.dataset.sku);
}

function getSelectedVariantSku() {
  try {
    if (window.Shopify && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      var v = window.ShopifyAnalytics.meta.selectedVariantId;
      if (v && window.meta && window.meta.product && window.meta.product.variants) {
        for (var i = 0; i < window.meta.product.variants.length; i++) {
          var row = window.meta.product.variants[i];
          if (String(row.id) === String(v) && row.sku) {
            return normalizeSku(row.sku);
          }
        }
      }
    }
  } catch (e) {}

  try {
    var el = document.querySelector(
      'form[action*="/cart/add"] [name="id"], product-form [name="id"]',
    );
    if (el && el.value && window.meta && window.meta.product && window.meta.product.variants) {
      for (var j = 0; j < window.meta.product.variants.length; j++) {
        var v2 = window.meta.product.variants[j];
        if (String(v2.id) === String(el.value) && v2.sku) {
          return normalizeSku(v2.sku);
        }
      }
    }
  } catch (e2) {}

  try {
    var variants = window.meta && window.meta.product && window.meta.product.variants;
    if (variants && variants[0] && variants[0].sku) {
      return normalizeSku(variants[0].sku);
    }
  } catch (e3) {}

  return null;
}

function getWidgetRoot() {
  return document.getElementById("kokobay-as-seen-on");
}

function hideWidget() {
  var root = getWidgetRoot();
  if (!root) return;
  root.hidden = true;
  root.innerHTML = "";
}

function cardHtml(item) {
  var user = instagramUsername(item.instagramUsername);
  var href = instagramHref(item);
  var src = safeHttpUrl(item.thumbnailUrl) || safeHttpUrl(item.imageUrl);
  if (!src) return "";

  var alt = user ? "As seen on @" + user : "As seen on";
  var width = Number(item.width) || 900;
  var height = Number(item.height) || 1200;
  var overlay =
    '<span class="kb-as-seen-on-ig-overlay" aria-hidden="true">' + IG_ICON + "</span>";
  var img =
    '<img src="' +
    escapeHtml(src) +
    '" alt="' +
    escapeHtml(alt) +
    '" width="' +
    width +
    '" height="' +
    height +
    '" loading="lazy" decoding="async">';

  var media = href
    ? '<a class="kb-as-seen-on-media" href="' +
      escapeHtml(href) +
      '" target="_blank" rel="noopener noreferrer">' +
      img +
      overlay +
      '<span class="visually-hidden">Open Instagram' +
      (user ? " @" + escapeHtml(user) : "") +
      "</span></a>"
    : '<div class="kb-as-seen-on-media">' + img + overlay + "</div>";

  var caption = "";
  if (user) {
    var name = "@" + escapeHtml(user);
    caption = href
      ? '<figcaption class="kb-as-seen-on-caption"><a class="kb-as-seen-on-username" href="' +
        escapeHtml(href) +
        '" target="_blank" rel="noopener noreferrer">' +
        name +
        "</a></figcaption>"
      : '<figcaption class="kb-as-seen-on-caption"><span class="kb-as-seen-on-username">' +
        name +
        "</span></figcaption>";
  }

  return (
    '<div class="kb-as-seen-on-slide">' +
    '<figure class="kb-as-seen-on-card">' +
    media +
    caption +
    "</figure></div>"
  );
}

function syncCarousel(root) {
  var track = root.querySelector(".kb-as-seen-on-track");
  var prev = root.querySelector(".kb-as-seen-on-nav--prev");
  var next = root.querySelector(".kb-as-seen-on-nav--next");
  if (!track || !prev || !next) return;

  var max = track.scrollWidth - track.clientWidth;
  var canScroll = max > 8;
  prev.hidden = !canScroll || track.scrollLeft <= 8;
  next.hidden = !canScroll || track.scrollLeft >= max - 8;
}

function scrollCarousel(root, direction) {
  var track = root.querySelector(".kb-as-seen-on-track");
  if (!track) return;
  var reduce =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  track.scrollBy({
    left: direction * track.clientWidth * 0.9,
    behavior: reduce ? "auto" : "smooth",
  });
}

function bindCarousel(root) {
  if (carouselBound) return;
  carouselBound = true;

  root.addEventListener("click", function (ev) {
    var btn = ev.target.closest && ev.target.closest(".kb-as-seen-on-nav");
    if (!btn || !root.contains(btn)) return;
    ev.preventDefault();
    scrollCarousel(root, btn.classList.contains("kb-as-seen-on-nav--next") ? 1 : -1);
  });

  root.addEventListener(
    "scroll",
    function (ev) {
      if (ev.target && ev.target.classList && ev.target.classList.contains("kb-as-seen-on-track")) {
        syncCarousel(root);
      }
    },
    true,
  );

  root.addEventListener("keydown", function (ev) {
    if (!ev.target || !ev.target.classList || !ev.target.classList.contains("kb-as-seen-on-track")) {
      return;
    }
    if (ev.key === "ArrowRight") {
      ev.preventDefault();
      scrollCarousel(root, 1);
    } else if (ev.key === "ArrowLeft") {
      ev.preventDefault();
      scrollCarousel(root, -1);
    }
  });

  if (typeof ResizeObserver === "function") {
    var ro = new ResizeObserver(function () {
      syncCarousel(root);
    });
    ro.observe(root);
  }

  window.addEventListener("resize", function () {
    syncCarousel(root);
  });
}

function renderWidget(data) {
  var images = data && Array.isArray(data.images) ? data.images : [];
  var productKey = data && (data.productId || data.handle);
  var root = getWidgetRoot();
  if (!root) return;

  if (productKey && String(productKey) === String(lastProductKey) && images.length) {
    if (!root.hidden && root.querySelector(".kb-as-seen-on")) {
      return;
    }
  }

  if (!images.length) {
    lastProductKey = null;
    hideWidget();
    return;
  }

  lastProductKey = productKey || lastSku;
  var slides = images
    .map(cardHtml)
    .filter(Boolean)
    .join("");
  if (!slides) {
    hideWidget();
    return;
  }

  root.hidden = false;
  root.removeAttribute("hidden");
  var centeredClass = images.length < 4 ? " kb-as-seen-on--centered" : "";
  root.innerHTML =
    '<section class="kb-as-seen-on' +
    centeredClass +
    '" aria-label="As seen on...">' +
    '<h2 class="kb-as-seen-on-title heading h2">As seen on...</h2>' +
    '<div class="kb-as-seen-on-carousel">' +
    '<button type="button" class="kb-as-seen-on-nav kb-as-seen-on-nav--prev" aria-label="Previous photos" hidden>' +
    CARET_LEFT +
    "</button>" +
    '<div class="kb-as-seen-on-track" tabindex="0">' +
    slides +
    "</div>" +
    '<button type="button" class="kb-as-seen-on-nav kb-as-seen-on-nav--next" aria-label="Next photos" hidden>' +
    CARET_RIGHT +
    "</button>" +
    "</div></section>";

  bindCarousel(root);
  requestAnimationFrame(function () {
    syncCarousel(root);
  });
}

async function loadAsSeenOnData(sku) {
  try {
    var response = await fetch(
      AS_SEEN_ON_API_BASE + "?sku=" + encodeURIComponent(sku),
      {
        method: "GET",
        credentials: "omit",
        headers: { Accept: "application/json" },
      },
    );
    if (!response.ok) return null;
    return await response.json();
  } catch (err) {
    console.error("As Seen On API failed", err);
    return null;
  }
}

async function loadForSku(sku) {
  var normalized = normalizeSku(sku);
  if (!normalized) {
    hideWidget();
    return;
  }
  if (normalized === lastSku && lastProductKey) return;

  lastSku = normalized;
  var data = await loadAsSeenOnData(normalized);
  renderWidget(data);
}

function onVariantMaybeChanged() {
  var sku = getSkuFromContainer() || getSelectedVariantSku();
  if (sku) void loadForSku(sku);
}

function subscribeVariantChanges() {
  try {
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        onVariantMaybeChanged();
      });
      return;
    }
  } catch (e) {}

  document.addEventListener("change", function (ev) {
    var t = ev.target;
    if (t && t.name === "id") onVariantMaybeChanged();
  });
}

function initAsSeenOnWidget() {
  if (!getWidgetRoot()) return;
  subscribeVariantChanges();
  onVariantMaybeChanged();
}

if (isTestQueryEnabled()) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAsSeenOnWidget);
  } else {
    initAsSeenOnWidget();
  }
}
